var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0,
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.171 253.23c8.8021-21.953 18.111-36.269 33.107-49.744 4.3748-3.931 8.9947-7.4952 13.849-10.689 26.693-17.562 60.473-23.929 99.554-18.512 2.0201-34.108 5.3498-67.074 23.655-99.889 13.451-24.113 33.591-44.393 68.496-66.803 89.137 61.531 86.914 128.03 88.489 173.04 93.302-30.419 120.34 43.292 108.09 90.683 109.54 42.035 35.2 204.85-76.691 145.84-60.153 24.771-98.97 4.3015-114-27.516-17.486-37.006-2.803-89.362 47.898-103.75-20.995-56.789 0.57556-85.087 33.931-105.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m163.39 175.38c13.756 71.57 40.588 96.864 58.244 113.68 11.581 11.029 21.749 17.44 30.08 21.192-14.625 141.59-206.56 143.52-234.14 26.536"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m248.08 311.89c21.555-2.4062 40.507-15.502 55.393-45.305"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m10.374 295.51c-0.07727-0.0148 1.2287-0.47461-1.0576-0.0304"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 451.95,
    cy: 57.862,
    rx: 50.07,
    ry: 50.115,
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m255.22 101.11c0.03 133.69 0.59065 188.44 0.62061 399.52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m213.38 177.44 41.452 40.922"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m289.64 139.35-29.505 28.289"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m133.47 264.16-0.68133 193.01c0.0291 15.946 0.77001 13.793-0.50298 45.186",
    strokeWidth: 14
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m7.9361 502.35 496.68-0.16462",
    strokeWidth: 14
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m93.504 285.93 36.367 35.299",
    strokeWidth: 20
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m182.28 317.31-44.5 43.242",
    strokeWidth: 20
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m372.04 295.38 2.0786 207.4",
    strokeWidth: 14
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m331.02 340.22 19.331 18.955 19.104 18.278",
    strokeWidth: 20
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m417.07 299.97-41.282 40.419",
    strokeWidth: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealification);
export default __webpack_public_path__ + "static/media/realification.b60a721085c82bad5fc8df2f9cb393dd.svg";
export { ForwardRef as ReactComponent };